
import "../css/Portfolio.css";
import "../css/platform.css";

import React, { useEffect, useState } from "react";

import { Header } from "../common/Header";

import { PortfolioContextProvider, usePortfolio, usePortfolioUpdate } from "../context/PortfolioContext";

import { fromCamelCaseToCapitalizedSpaced } from "../utilities/helpers";

import { reportInteraction } from "../utilities/server-update-analytics";




const Portfolio = () => {


  return (
    <>
      <PortfolioContextProvider>
        <Header content={<HeaderContent />} />

        <Main />
      </PortfolioContextProvider>
    </>
  );
};

const HeaderContent = () => {

  const { coachData } = usePortfolio();

  if( !coachData ) return <></>;

  return (
    <div className="platform_page_header_container">
      <div className="platform_page_header_content">
        <h1>{coachData?.coachName}</h1>
        <p>{coachData?.tagline}</p>
      </div>
    </div>
  )
};


function Main() {

  return (
  <main className="platform_body">
      <section id="portfolio" className="portfolio_section">
        <DisciplineNav />

        <div className="content-container">
          <ContentNav />
          <ContentGrid />
        </div>
      </section>
      <ContactSection />
    </main>
  );
}

function DisciplineNav() {

  const { disciplines, selectedDiscipline } = usePortfolio();
  const { updateSelectedDiscipline } = usePortfolioUpdate();

  if( !disciplines || !selectedDiscipline ) return <></>;

  return (
    <div className="portfolio_discipline_nav">
      {disciplines.map((discipline: any) => {

        if( !discipline.visible ) return <></>;

        return (
          <button
            key={discipline.selector}
            className={`portfolio_discipline_nav_button ${selectedDiscipline.selector === discipline.selector ? "active" : ""}`}
            onClick={() => updateSelectedDiscipline(discipline.selector)} >

            {fromCamelCaseToCapitalizedSpaced(discipline.selector)}
          </button>
        );
      })}
    </div>
  );
}

function ContentNav() {

  const { selectedDiscipline, contentKeys, selectedContent } = usePortfolio();
  const { updateSelectedContent } = usePortfolioUpdate();

  if( !selectedDiscipline || !contentKeys ) return <></>;

  const contentSelector = selectedContent ? selectedContent.selector : contentKeys[0];

  console.log(selectedDiscipline);

  return (
    <div className="portfolio_content_nav">
      {contentKeys.map((contentKey: any) => {

        if( contentKey !== "all" ) {
          const content = selectedDiscipline.content.find( (c: any) => c.selector === contentKey );
          if( !content || !content.visible ) return <></>;
        }

        return (
          <button key={contentKey} 
                  className={`portfolio_content_nav_button ${contentSelector === contentKey ? "active" : ""}`} 
                  onClick={() => updateSelectedContent(contentKey)} >

            {fromCamelCaseToCapitalizedSpaced(contentKey)}
          </button>
        );
      })}
    </div>
  );
}



/* ================================= Content Grid ================================== */

function ContentGrid() {

  const { selectedDiscipline, selectedContent } = usePortfolio();

  if( !selectedDiscipline ) return <></>;

  return (
    <div className="portfolio_content_grid">
      {
        renderContentSection( selectedDiscipline, selectedContent?.selector )
      }
    </div>
  );
}

function renderContentSection( selectedDiscipline: any, contentSelector: string | undefined ) {

  const sections = [
    // TODO: Shouldn't need pass data to each Component, should be able to just get / use from within each Component ...
    { selector: "introduction", component: <Introduction selectedDiscipline={selectedDiscipline} /> },
    { selector: "skills", component: <Skills selectedDiscipline={selectedDiscipline} /> },
    { selector: "experience", component: <Experience selectedDiscipline={selectedDiscipline} /> },
    { selector: "projects", component: <Projects selectedDiscipline={selectedDiscipline} /> },
    { selector: "education", component: <Education selectedDiscipline={selectedDiscipline} /> },
    { selector: "certifications", component: <Certifications selectedDiscipline={selectedDiscipline} /> },
    { selector: "interests", component: <Interests selectedDiscipline={selectedDiscipline} /> },
    { selector: "contact", component: <Contact selectedDiscipline={selectedDiscipline} /> },
    { selector: "testimonials", component: <Testimonials selectedDiscipline={selectedDiscipline} /> },
    { selector: "video", component: <VideoShowcase selectedDiscipline={selectedDiscipline} /> },
  ];

  const activeSection = sections.find( section => section.selector === contentSelector );

  return activeSection ? activeSection.component : (
    <>
      {sections.map(section => section.component)}
    </>
  );
}




/* =============================== Content Sections ================================ */

function Introduction({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find( (c: any) => c.selector === "introduction" );

  if( !selectedContent || !selectedContent.visible ) return <></>;

  return (
    <Card title="Introduction" content={<p>{selectedContent.text}</p>} />
  );
}

function Skills({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find(
    (c: any) => c.selector === "skills"
  );

  if( !selectedContent || !selectedContent.visible ) return <></>;

  return (
    <div className="portfolio_content_grid">
      {
        Object.keys(selectedContent.skills).map((skill: string) => (
          <div key={skill} className="portfolio_content_grid_card">
            <h3>{fromCamelCaseToCapitalizedSpaced(skill)}</h3>
            <div>
              {selectedContent.skills[skill].map((subSkill: any) => (
                <span key={`${skill}-${subSkill.name}`} className={`portfolio_content_grid_card_skill ${subSkill.level.toLowerCase()}`}>
                  {subSkill.name}
                  <div className="skill_level_tooltip">
                    {subSkill.level}
                  </div>
                </span>
              )
              )}
            </div>
          </div>
        ))
      }
    </div>
  );
}

function Experience({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find(
    (c: any) => c.selector === "experience"
  );

  if( !selectedContent || !selectedContent.visible ) return <></>;

  return (
    <div className="portfolio_content_grid">
      {selectedContent.experience.map((exp: any, index: number) => {

        const isPresent = exp.endDate.toLowerCase() === "present";

        return (
          <div key={index} className={`portfolio_content_grid_card ${isPresent ? "present-experience" : ""}`}>

            <h3>{exp.role} - {exp.company}</h3>
            <p>
              <strong>From:</strong> {exp.startDate} <strong>To:</strong> {exp.endDate}
            </p>
            <p>{exp.description}</p>
          </div>
        );
      })}
    </div>
  );
}

function Projects({ selectedDiscipline }: { selectedDiscipline: any }) {
  const [expandedImage, setExpandedImage] = useState<string | null>(null);
  const [expandedVideo, setExpandedVideo] = useState<string | null>(null);


  const selectedContent = selectedDiscipline.content.find(
    (c: any) => c.selector === "projects" // TODO: Use Enum for Content Selectors, if create one (add to shared repo)
  );

  if (!selectedContent || !selectedContent.visible) return <></>;

  const handleImageClick = (imageSrc: string, projectTitle: string) => {
    setExpandedImage(imageSrc); // Set the image to expand

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "portfolio_project_teaser_image"
      },
      additionalDetails: {
        selectedDiscipline: selectedDiscipline?.selector,
        selectedContent: "projects", // TODO: Use Enum for Content Selectors, if create one (add to shared repo)
        projectTitle: projectTitle,
      }
    });
  };

  const handleVideoClick = (videoSrc: string, projectTitle: string) => {
    setExpandedVideo(videoSrc); // Set the video to expand

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "portfolio_teaser_video_button"
      },
      additionalDetails: {
        selectedDiscipline: selectedDiscipline?.selector,
        selectedContent: "projects", // TODO: Use Enum for Content Selectors, if create one (add to shared repo)
        projectTitle: projectTitle,
      }
    });
  };

  const handleClose = () => {
    setExpandedImage(null); // Close the image modal
    setExpandedVideo(null);  // Close the video modal
  };


  const reportProjectLinkClick = ( link: string, projectTitle: string ) => {
    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "portfolio_content_grid_card a"
      },
      additionalDetails: {
        selectedDiscipline: selectedDiscipline?.selector,
        selectedContent: "projects", // TODO: Use Enum for Content Selectors, if create one (add to shared repo)
        projectTitle: projectTitle,
        link: link,
      }
    });
  };


  return (
    <div className="portfolio_content_grid">
      {selectedContent.projects.map((project: any, index: number) => (
        <div key={index} className={`portfolio_content_grid_card ${project.teaserImageSrc ? "two-column" : ""}`}>
          <h3>{project.title}</h3>
          <p>{project.description}</p>


          {/* Teaser Image */}
          {project.teaserImages && project.teaserImages.length > 0 && (
            /* TODO: This lags in loading cuz image hosted in G-Drive (same for Video below)
               ... Find way to use link that is on server
               ... Issue cuz "build" React causes unique name to file 
               ... and doesn't seem place automatically in build/static/img folder 
               ... (research better way)
            */
            <div className="portfolio_project_teaser_image_container">
              {
                project.teaserImages.map((image: any, index: number) => (
                  <div>
                    <img 
                      className="portfolio_project_teaser_image"
                      src={image.src} 
                      alt={`${project.title} teaser`} 
                      onClick={() => handleImageClick(image.src, project.title)} // Open Modal on click
                    />
                    <svg className="magnifying-glass_icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
                  </div>
                ))
              }
            </div>
          )}

          {/* Teaser Video Button */}
          {project.teaserVideos && (
              project.teaserVideos.length === 1 ?
                (
                  <button className="portfolio_teaser_video_button" onClick={() => handleVideoClick(project.teaserVideos[0].src, project.title)}>
                    Teaser Video
                  </button>
                )
              :
                (
                  <div>
                    {project.teaserVideos.map((video: any, index: number) => (
                      <button key={index} className="portfolio_teaser_video_button" onClick={() => handleVideoClick(video.src, project.title)}>
                        {video.name} Video
                      </button>
                    ))}
                  </div>
                )
            )
          }


          {project.features && project.features?.length > 0 && (
            <ExpandableFeatures features={project.features} projectTitle={project.title} />
          )}

          {project.technologies && project.technologies.length > 0 && (
            <div>
              <h4>Technologies:</h4>
              <div>
                {project.technologies.map((tech: string, idx: number) => (
                  <span key={idx} className="portfolio_content_grid_card_skill">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Links Section */}
          {project.links && project.links.length > 0 && (
            <div className="portfolio_project_links">
              <h4>Links:</h4>
              <ul>
                {project.links.map((link: any, linkIndex: number) => (
                  <li key={linkIndex}>
                    <a href={link.url} target="_blank" rel="noopener noreferrer" onClick={() => reportProjectLinkClick(link.url, project.title)}>
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}

      {/* Image Modal */}
      {expandedImage && (
        <ImageModal onClose={handleClose} imageSrc={expandedImage} />
      )}

      {/* Video Modal */}
      {expandedVideo && (
        <VideoModal onClose={handleClose} videoSrc={expandedVideo} />
      )}
    </div>
  );
}


function Education({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find(
    (c: any) => c.selector === "education"
  );

  if( !selectedContent || !selectedContent.visible ) return <></>;

  return (
    <div className="portfolio_content_grid">
      {
        selectedContent.education.map((edu: any, index: number) => (
          <div key={index} className="portfolio_content_grid_card">
            <h3>{edu.degree} in {edu.major}</h3>
            {edu.minor && <p><strong>Minor:</strong> {edu.minor}</p>}
            <p><strong>School:</strong> {edu.school}</p>
            <p><strong>Graduation Date:</strong> {edu.graduationDate}</p>
          </div>
        ))
      }
    </div>
  );
}

function Certifications({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find(
    (c: any) => c.selector === "certifications"
  );

  if( !selectedContent || !selectedContent.visible ) return <></>;

  return (
    <div className="portfolio_content_grid">
      <div className="portfolio_content_grid_card">
        <h3>Certifications</h3>
        <ul>
          {selectedContent.certifications.map((cert: string, index: number) => (
            <li key={index}>{cert}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function Interests({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find(
    (c: any) => c.selector === "interests"
  );

  if (!selectedContent || !selectedContent.visible) return <></>;

  return (
    <div className="portfolio_content_grid">
      <div className="portfolio_content_grid_card">
        <h3>Current Interests</h3>
        <ul>
          {selectedContent.interests.map((interest: string, index: number) => (
            <li key={index}>{interest}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function Contact({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find(
    (c: any) => c.selector === "contact"
  );

  if( !selectedContent || !selectedContent.visible ) return <></>;

  const reportContactClick = ( link: string ) => {
    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "portfolio_content_grid_card a"
      },
      additionalDetails: {
        selectedDiscipline: selectedDiscipline?.selector,
        selectedContent: "contact", // TODO: Use Enum for Content Selectors, if create one (add to shared repo)
        link: link,
      }
    });
  };

  return (
    <div className="portfolio_content_grid">
      <div className="portfolio_content_grid_card">
        <h3>Contact Information</h3>
        <p><strong>Email:</strong> {selectedContent.contact.email}</p>
        <p><strong>Phone:</strong> {selectedContent.contact.phone}</p>
        <p><strong>LinkedIn:</strong> <a href={selectedContent.contact.linkedIn} target="_blank" rel="noopener noreferrer" onClick={() => reportContactClick(selectedContent.contact.linkedIn)}>{selectedContent.contact.linkedIn}</a></p>
        <p><strong>GitLab:</strong> <a href={selectedContent.contact.gitLab} target="_blank" rel="noopener noreferrer" onClick={() => reportContactClick(selectedContent.contact.gitLab)}>{selectedContent.contact.gitLab}</a></p>
        <p><strong>GitHub:</strong> <a href={selectedContent.contact.gitHub} target="_blank" rel="noopener noreferrer" onClick={() => reportContactClick(selectedContent.contact.gitHub)}>{selectedContent.contact.gitHub}</a></p>
      </div>
    </div>
  );
}

function Testimonials({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find( (c: any) => c.selector === "testimonials" );

  if( !selectedContent || !selectedContent.visible ) return <></>;

  return (
    selectedContent.testimonials.map((testimonial: any, index: number) => (
      <Card key={index} title="Testimonial" content={
        <div className="portfolio_testimonial">
          <p>"{testimonial.text}"</p>
          <p>- {testimonial.author}</p>
        </div>
      } />
    ))
  );
}

function VideoShowcase({ selectedDiscipline }: { selectedDiscipline: any }) {
  const selectedContent = selectedDiscipline.content.find( (c: any) => c.selector === "video" );

  if( !selectedContent || !selectedContent.visible ) return <></>;

  // TODO: Could handle videos this way... Where can just use YouTube video link... (make private / only accessible via link)
  // ... At least wouldn't use up my Google Drive stroage space. But would it scale for other Coaches?

  return (
    <Card title="Video Showcase" content={
      <div className="portfolio_content_grid_card_video_container">
        <iframe
          src={selectedContent.video}
          title="Showcase Video"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>
    } />
  );
}



/* =============================== Contact Section ================================ */

function ContactSection() {

  const { selectedDiscipline } = usePortfolio();

  if( !selectedDiscipline ) return <></>;

  const selectedContent = selectedDiscipline.content.find( (c: any) => c.selector === "contact" );

  return (
    <section id="contact" className="portfolio_section">
      <h2>Get in Touch</h2>
      <div className="portfolio_content_grid_card">
        <h3>Contact Information</h3>
        {/*<p><strong>Email:</strong> {selectedContent.contact.email}</p>*/}
        {/*<p><strong>Phone:</strong> {selectedContent.contact.phone}</p>*/}
        <p><strong>LinkedIn:</strong> <a href={selectedContent.contact.linkedIn} target="_blank" rel="noopener noreferrer">{selectedContent.contact.linkedIn}</a></p>
        <p><strong>GitLab (primary):</strong> <a href={selectedContent.contact.gitLab} target="_blank" rel="noopener noreferrer">{selectedContent.contact.gitLab}</a></p>
        <p><strong>GitHub:</strong> <a href={selectedContent.contact.gitHub} target="_blank" rel="noopener noreferrer">{selectedContent.contact.gitHub}</a></p>
      </div>
    </section>
  );
}



/* ================================== Helpers ==================================== */

function Card({ title, content }: { title: any, content: any }) {
  return (
    <div className="portfolio_content_grid_card">
      <h2>{title}</h2>
      {content}
    </div>
  );
}

function ExpandableFeatures({ features, projectTitle }: { features: string[], projectTitle: string }) {
  const [showMore, setShowMore] = useState(false);

  const { selectedDiscipline } = usePortfolio();
  const { selectedContent } = usePortfolio();

  const handleToggle = () => {
    setShowMore(!showMore);

    if( !showMore ) { // I.e. was not showing more, now is (since React state not re-rendered yet)
      reportInteraction({
        interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
        interactionDetails: {
          elementId: "portfolio_content_features portfolio_content_show_more_toggle"
        },
        additionalDetails: {
          selectedDiscipline: selectedDiscipline?.selector,
          selectedContent: selectedContent?.selector,
          projectTitle: projectTitle,
          showMore: showMore,
        }
      });
    }
  }


  // Show only 3 features initially
  const visibleFeatures = showMore ? features : features.slice(0, 3);

  return (
    <div>
      <h4>Features:</h4>
      <div className="portfolio_content_features">
        {visibleFeatures.map((feature, index) => (
          <span key={index} className="portfolio_content_grid_card_skill">
            {feature}
          </span>
        ))}
      </div>
      {features.length > 3 && (
        <span className="portfolio_content_show_more_toggle" onClick={handleToggle}>
          {showMore ? "Show Less" : "Show More"}
        </span>
      )}
    </div>
  );
}

function ImageModal({ onClose, imageSrc }: { onClose: () => void, imageSrc: string }) {

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="image_modal_overlay" onClick={onClose}>
      <div className="image_modal_content" onClick={(e) => e.stopPropagation()}>
        <span className="close_button" onClick={onClose}>
          &times;
        </span>
        <img src={imageSrc} alt="Expanded project teaser" />
      </div>
    </div>
  );
}

function VideoModal({ onClose, videoSrc }: { onClose: () => void, videoSrc: string }) {

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose(); // Close the modal if Escape is pressed
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="video_modal_overlay" onClick={onClose}>
      <div className="video_modal_content" onClick={(e) => e.stopPropagation()}>
        <span className="close_button" onClick={onClose}>
          &times;
        </span>
        <iframe
          src={videoSrc}
          title="Teaser Video"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
}




export default Portfolio;

